export default {
  jp:[
    "individual.address_kana.postal_code",
    "individual.address_kana.city",
    "individual.address_kana.state",
    "individual.address_kana.town",
    "individual.address_kana.line1",
    "individual.address_kanji.postal_code",
    "individual.address_kanji.state",
    "individual.address_kanji.city",
    "individual.address_kanji.town",
    "individual.address_kanji.line1",
    "individual.first_name_kana",
    "individual.first_name_kanji",
    "individual.last_name_kana",
    "individual.last_name_kanji",
    "individual.dob.day",
    "individual.dob.month",
    "individual.dob.year",
    "individual.gender",
    "individual.phone",
  ],
  us: [
    "individual.postal_code",
    "individual.city",
    "individual.state",
    "individual.town",
    "individual.line1",
    "individual.first_name",
    "individual.last_name",
    "individual.dob.day",
    "individual.dob.month",
    "individual.dob.year",
    "individual.gender",
    "individual.phone",

  ]
}
